import { CSSObject } from '@emotion/core';
import Link from 'next/link';
import { useMemo, useState } from 'react';
import Media from 'react-media';

import { VirtualCategory } from '@api/catalog';

import { Button, colors, scale, useTheme } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';

import { getSorted } from '../helper';

const buttonOptionStyles: CSSObject = {
    height: scale(5),
    padding: `6px ${scale(2)}px !important`,
    borderRadius: `${scale(9, true)}px !important`,
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
};

const VirtualCategories = ({ virtual_categories }: { virtual_categories: VirtualCategory[] }) => {
    const { layout } = useTheme();
    const { xs } = useMedia();

    const categories = useMemo(() => (getSorted(virtual_categories) || []).slice(0, 20), [virtual_categories]);

    const [isHidden, setIsHidden] = useState(true);

    return (
        <Media query={{ maxWidth: layout?.breakpoints.xs || 568 }} defaultMatches={false}>
            {matches => (
                <>
                    <div css={{ color: colors.textLight, marginBottom: scale(5, true) }}>Популярные запросы</div>

                    <div
                        css={{
                            display: 'flex',
                            gap: scale(2),
                            flexWrap: 'wrap',
                            [xs]: {
                                overflowX: 'auto',
                                flexWrap: 'nowrap',
                                '::-webkit-scrollbar': { display: 'none' },
                            },
                        }}
                    >
                        {categories.slice(0, isHidden && !matches ? 5 : categories.length).map(item => (
                            <Link
                                href={`/catalog/collections/${item.code}`}
                                passHref
                                prefetch={false}
                                key={item.id}
                                legacyBehavior
                            >
                                <Button
                                    as="a"
                                    theme="outlineGreyAndPrimary"
                                    size="sm"
                                    css={buttonOptionStyles}
                                    data-testid={`button-${item.code}`}
                                >
                                    {item.name}
                                </Button>
                            </Link>
                        ))}
                    </div>

                    <div
                        css={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: scale(5, true),
                            [xs]: { display: 'none' },
                        }}
                    >
                        {categories.length > 5 && (
                            <Button
                                data-testid="button-categories"
                                theme="transparenLightGrey"
                                size="sm"
                                onClick={() => setIsHidden(prev => !prev)}
                                css={{ minWidth: 'fit-content' }}
                            >
                                {isHidden ? 'Показать все запросы' : 'Свернуть все запросы'}
                            </Button>
                        )}
                    </div>
                </>
            )}
        </Media>
    );
};

export default VirtualCategories;
